import { FormattedMessage } from 'react-intl';
import { Link } from '@repo/poly-hooks/components';
import { shouldSkipKyc } from '@repo/identity-verification-kit/utils/should-skip-kyc';
import { useKycInfo } from '@repo/identity-verification-kit/hooks/use-kyc';
import styles from './almost-ready.module.css';

interface AlmostReadyProps {
  registrationId: string;
  legalCountry: string;
}

export function AlmostReady({ registrationId, legalCountry }: AlmostReadyProps): React.ReactNode {
  const { data: kycInfo } = useKycInfo(legalCountry);
  const skipKyc = shouldSkipKyc(kycInfo ?? null);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.content}>
        <span className={styles.icon}>
          <img alt="" aria-hidden="true" src="/icon/almost-ready.svg" />
        </span>
        <h1 className="heading-section mb-16" data-test-registrations-almost-ready-title>
          <FormattedMessage
            defaultMessage="Your payment has been processed"
            id="almost-ready.title"
          />
        </h1>
        <p className="body-standard mb-32" data-test-registrations-almost-ready-subtitle>
          {skipKyc ? (
            <FormattedMessage
              defaultMessage="You'll receive your purchase invoice by email shortly.{br}{br}Your payment has been processed. You can start now the capital deposit process."
              id="almost-ready.subtitle-skip-kyc"
              values={{
                br: <br />,
              }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="You'll receive your purchase invoice by email shortly.{br}{br}Before you start the capital deposit process, <strong>let's verify your identity</strong>."
              id="almost-ready.subtitle"
              values={{
                br: <br />,
                strong: text => <strong>{text}</strong>,
              }}
            />
          )}
        </p>
        <Link
          className="btn btn--primary"
          data-test-registrations-continue-button
          to={`/registrations/${registrationId}/kyc`}
        >
          <FormattedMessage id="button.continue" />
        </Link>
      </div>
    </div>
  );
}
